import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { Category } from "../../types/Lessons";

type CategoryAutocompleteProps = {
  options: Array<Category>;
  value?: Category[];
  disabled?: boolean;
  onChange: (categories: Category[] | null) => void;
  placeholder: string;
};

const CategoryAutocomplete = (props: CategoryAutocompleteProps) => (
  <Autocomplete
    options={props.options}
    defaultValue={props.value}
    fullWidth
    multiple
    disabled={props.disabled}
    getOptionLabel={(category) => category.name}
    isOptionEqualToValue={(option, value) => option.id === value.id}
    onChange={(e, categories) => props.onChange(categories)}
    sx={{['.MuiAutocomplete-inputRoot'] : { padding: "0.5rem !important" }}}
    renderInput={(params) => (
      <TextField
        {...params}
        variant="filled"
        size="small"
        placeholder={props.placeholder}
      />
    )}
  />
);

export default CategoryAutocomplete;